import api from "./api";

export const offlineSyncService = {
  getSummary: async (token, { signal } = {}) => {
    const res = await api.get("/repo-cases/offline-sync/summary", {
      signal,
      timeout: 60000,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  getRecords: async (token, params, { signal } = {}) => {
    const res = await api.get("/repo-cases/offline-sync/records", {
      params,
      signal,
      timeout: 120000,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  getIds: async (token, params, { signal } = {}) => {
    const res = await api.get("/repo-cases/offline-sync/ids", {
      params,
      signal,
      timeout: 120000,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },
};
